import { Flex } from "@chakra-ui/react";
import { useEffect } from "react";
import Layout from "@/components/layout/layout";
import { Route, Routes, useLocation } from "react-router-dom";
import ScenariosPage from "@/pages/scenarios/ScenariosPage";
import ScenarioPage from "@/pages/scenario/ScenarioPage";
import { Toaster } from "@/components/ui/toaster";
import ChatPage from "@/pages/chat/ChatPage";
import ChatWidgets from "@/components/layout/ChatWidgets";
import EndpointsPage from "@/pages/endpoints/EndpointsPage";
import WorkersPage from "@/pages/workers/WorkersPage";
import SettingsPage from "@/pages/settings/SettingsPage";
import AccountPage from "@/pages/account/AccountPage";
import { useEndpointContext } from "@/components/providers/EndpointProvider";
import { AuthProvider } from "@/auth/AuthContext";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import LoginPage from "@/pages/login/LoginPage";
import UsersPage from "@/pages/users/UsersPage";
import SetPasswordPage from "@/pages/activation/SetPasswordPage";
import ForgotPasswordPage from "@/pages/activation/ForgotPasswordPage";
import ModelsPage from "@/pages/models/ModelsPage";
import ModelDetailPage from "@/pages/models/ModelDetailPage";
import ClientsPage from "@/pages/clients/ClientsPage";
import ClientDetailPage from "@/pages/clients/ClientDetailPage";
import InteractionDetailPage from "@/pages/clients/InteractionDetailPage";
import WorkflowDetailPage from "@/pages/clients/WorkflowDetailPage";
import CampaignDetailPage from "@/pages/clients/CampaignDetailPage";
import RecruitmentTestsPage from "@/pages/recruitmentTests/RecruitmentTestsPage";

const AppContent = () => {
    const location = useLocation();
    const showChatWidgets = location.pathname !== '/chat';
    const { softRefresh } = useEndpointContext();

    useEffect(() => {
        softRefresh();
    }, [location.pathname]);

    return (
        <AuthProvider>
            <Flex gap={0} spacing={0} px={0} w="100%" className="test">
                <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/activation/:token" element={<SetPasswordPage mode="activation" />} />
                    <Route path="/reset-password/:token" element={<SetPasswordPage mode="reset" />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route element={<ProtectedRoute />}>
                        <Route element={<Layout />}>
                            <Route path="/" element={<ScenariosPage />} />
                            <Route path="/scenarios" element={<ScenariosPage />} />
                            <Route path="/scenarios/:scenarioId" element={<ScenarioPage />} />
                            <Route path="/endpoints" element={<EndpointsPage />} />
                            <Route path="/workers" element={<WorkersPage />} />
                            <Route path="/settings" element={<SettingsPage />} />
                            <Route path="/account" element={<AccountPage />} />
                            <Route path="/models" element={<ModelsPage />} />
                            <Route path="/models/:id" element={<ModelDetailPage />} />
                        </Route>
                        <Route path="/chat" element={<ChatPage />} />
                    </Route>
                    <Route element={<ProtectedRoute requireRole="Admin" />}>
                        <Route element={<Layout />}>
                            <Route path="/users" element={<UsersPage />} />
                            <Route path="/clients" element={<ClientsPage />} />
                            <Route path="/clients/:id" element={<ClientDetailPage />} />
                            <Route path="/clients/:id/interactions/:interactionId" element={<InteractionDetailPage />} />
                            <Route path="/clients/:id/workflows/:workflowId" element={<WorkflowDetailPage />} />
                            <Route path="/clients/:id/campaigns/:campaignId" element={<CampaignDetailPage />} />
                            <Route path="/recruitment-tests" element={<RecruitmentTestsPage />} />
                        </Route>
                    </Route>
                </Routes>
            </Flex>
            <Toaster />
            {showChatWidgets && <ChatWidgets />}
        </AuthProvider>
    );
};

export default AppContent;
